import React from 'react';
import './ProfilePicture.css';

const ProfilePicture = ({ 
  src, 
  alt = 'Profile Picture', 
  size = 'medium',
  placeholder = '/profile-placeholder.png'
}) => {
  const handleImageError = (e) => {
    e.target.src = placeholder;
  };

  return (
    <div className={`profile-picture ${size}`}>
      <img 
        src={src || placeholder}
        alt={alt}
        className="profile-image"
        onError={handleImageError}
      />
    </div>
  );
};

export default ProfilePicture;